import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { noop } from 'lodash';

import MuiMenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import { EMPTY_OBJECT } from '@e-socna/empty';

import type { Option } from './types/option.type';

interface Props {
  readonly onCloseMenu: () => void;
  readonly option: Option;
}

export const MenuItem = ({
  onCloseMenu,
  option: { action, children, key, to, title },
}: Readonly<Props>) => {
  const handleClick = useCallback(() => {
    (action ?? noop)();
    onCloseMenu();
  }, [action, onCloseMenu]);

  return (
    <MuiMenuItem
      key={key}
      onClick={handleClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(to ? { component: Link, to } : EMPTY_OBJECT)}
    >
      {children ?? (
        <Typography sx={{ textAlign: 'center' }}>{title}</Typography>
      )}
    </MuiMenuItem>
  );
};
